import React, { useState } from "react";
import {
  FaRegEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaImdb
} from "react-icons/fa";
// import { BiLogoImdb } from "react-icons/bi"
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";

export default function Footer({ modal }) {
  const [slug, setSlug] = useState('')
  const [classes, setClasses] = useState('')

  const location = useLocation()

  useState(() => {
    if (location) {

      const pathname = location.pathname
      const regex = /\/([^/]+)$/
      const slugExtracted = pathname.match(regex)
      if (slugExtracted) {
        const cleanSlug = slugExtracted[1];
        setSlug(cleanSlug)
      }

    }
  }, [location])

  const checkPage = page => {
    switch (page) {
      case 'jlr-spaces':
        // return 'md:absolute relative'
        return 'md:absolute relative'
      case 'jlr-travels':
        // return 'md:relative absolute'
        return 'travel-footer relative'
      case 'jlr-foods':
        // return 'md:absolute relative'
        return 'travel-footer relative'
      case 'jovy-rabelas':
        // return 'relative'
        return 'fixed'
      default:
        const absolutes = ['about', 'spaces', 'travel', 'food'];
        return absolutes.includes(page) || !page ? 'absolute' : 'md:fixed relative'

      // return 'md:absolute relative'
      // return 'absolute'
    }
  }

  return (
    <>
      {/* <footer className="absolute w-full bottom-0 bg-black"> */}
      <footer className={`${checkPage(slug)} bottom-0 w-full bg-black max-w-[1920px] left-1/2 -translate-x-2/4 z-10`}>
        <div className="md:px-10 px-5 py-5 flex justify-between">
          <div className="">
            <div className="md:text-md text-xs text-white">
              {new Date().getFullYear()} &copy; JL Rabelas
              <br />
              590 Madison Avenue, NYC 10022 NY
            </div>
          </div>
          <div className="flex gap-2 justify-center items-center" id="socials">
            <Link to="https://www.linkedin.com/in/jovy-rabelas-40862690/" target="_blank">
              <div
                className="s-item flex justify-center items-center bg-white md:w-10 w-9 md:h-10 h-9 rounded-full cursor-pointer"
                tabIndex="0"
              >
                <div className="s-icon text-black md:text-xl text-md self-center">
                  <FaLinkedinIn />
                </div>
              </div>
            </Link>
            <Link to="https://www.facebook.com/jovy.rabelas" target="_blank">
              <div
                className="s-item flex justify-center items-center bg-white md:w-10 w-9 md:h-10 h-9 rounded-full cursor-pointer"
                tabIndex="0"
              >
                <div className="s-icon text-black md:text-xl text-md self-center">
                  <FaFacebookF />
                </div>
              </div>
            </Link>
            <Link to="https://www.instagram.com/jovrabelas/" target="_blank">
              <div
                className="s-item flex justify-center items-center bg-white md:w-10 w-9 md:h-10 h-9 rounded-full cursor-pointer"
                tabIndex="0"
              >
                <div className="s-icon text-black md:text-xl text-md self-center">
                  <FaInstagram />
                </div>
              </div>
            </Link>
            <Link to="https://www.imdb.com/name/nm13920840/?ref_=nv_sr_srsg_0_tt_5_nm_3_q_jovy%2520ra" target="_blank">
              <div
                className="s-item flex justify-center items-center bg-white md:w-10 w-9 md:h-10 h-9 rounded-full cursor-pointer"
                tabIndex="0"
              >
                <div className="s-icon text-black md:text-xl text-md self-center">
                  <svg width="40" height="40" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                    <rect width="49" height="49" fill="url(#pattern0)" />
                    <defs>
                      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use href="#image0_1018_1286" transform="scale(0.0078125)" />
                      </pattern>
                      <image id="image0_1018_1286" width="128" height="128" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAUpSURBVHhe7ZxZyG1jGMc/hYwZEoWUzEOZiSgziWQ4OBeHczJcma+UooiQmZRwoSTFxelc4MIdZR4uKMkQyTxdmIf4/2s/tXp71l5rf71rf9b5fr/63TzP++3vfHv/19rvete7zgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArI9sKu+Xj03xLGm2k4/IbEzp3XJjGWwk75LZ2MxdpDlRZv3Q/56HpH/fTfIauVIeKbeWbVwvs9cLj5LLAr9J/3boD87sLrN+m7vKYCeZjWnzMGmuk1m/j9/Ix+V+suR9mf1MeKlcFmwlv5PZmxDeLI0/0L9kNibzeBn4A83GtHmQNFfJrD+Lv8pzZZNXZDY2vFAuC4YMwCUyOFtmY9qsGQD7p9xXBgRgwpABuF0G/m7OxrRZOwD2aRkQgAlDBuAZGXiimY1ps28A/pE/yL8btTZ/lFtI0xWAi2SwmdxfHi73ks3J7egZMgCvyWCdzMa02TcAv8l95J7y+UltmntL0xWAM+Um8k752aQWfixvk5vL0TNkAD6Xvvwzb8lsTJuzBGB7aU6S2ZimR0jTFQBfUr5a1Erd99lh1AwZAE+8fPm3gfxyUuvrLAHYWRpf+2djmh4nTVcA+nqjHDVDBsAeKr3W4DBk/TYXE4A+l5qnSlMrAO/JUTN0ALyK6O/nrDfNoQJwujRdAfhaPiD9fZ/1Q5/ZvJo6WmoFwLPxrHet9Gm3rP8kp50VhgrAGdJ0BSBO7Stk1g/93vk9HC21AuD6R0XNPigvK2rWk0Kv0JX1cKkDcLE0Xa/5vdxGjpaaZ4Dnipp9Vt5X1KwXZfzhlfVwqQMQC0EHyqwfEoCGPtp/KWq+6fJiUfNr3CGnLd4QgDlRMwC+c/dFUftd/lzUvCJ3RVErJQBzomYAVsu3i1rmh/K8olZKAOZEzQB4+bTPku9L8oSiVkoA5kTNAJws7y1qmU9K31jJeiEBmBM1A+Cj+vKilnmr7HpjCcCcqBkA34zxUmvWa+qNIgTgf0LNAJwm9yhqmd4qdnBRKyUAc6L2JND30H3pl/XD3aRvy2a9kADMiZoBOEeaT2XWt17+dUiObtQyFxOAromlJQAFNQPga3tTrvw1/USaY2XWDxcTgGNkNqZp37uBBKBh3wCcL4334md963AYzwOyfriYAPjozsY0PUUaAjBhiADcILO+fUIaP/GT9cO+AYivFOMHWLIxTX2WMF0BWCPNITLrhwSgYQTgApn1bbxWrQB4T4EfC3tKTvu3hQdI0xWAq6XxI2JZP/xKjnpz6BABmDbDjyOr1lLwLPrqZAdpugLgvo/+Rxu1zA+k9zyOliEC4I2g/m7OxnjyZ5YiAO/IoCsAfX1BjpohArCh9Gy/7Pv+vx8wNUsRgFUyqBWA+KoYLQ6A789nf1x4izQOQNYP/d0fZJeCnjDFkzldcwCvFJpZHylr0/cfmrwus3HhPbLcx1D6hhz1hlDjAHwrfXRmequXH5IwDsAfsm2cN1AGfsbetWb/TRn4DNDsl8YZ4Eo5bVypJ4XeleRdvT7lPyyzZ/1fltnruub3w/g5g3dl9uGvldvK0eMJjD9Yn5rbjD/Up/asH8bRbfwzZX9HGfjIKftN4/k7BzTrt+m/xb9nSzkNrx1kP29jXcH4ySZvbfcWNv9HFL7E9SomAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKzPLCz8B7dvM0Bu9KduAAAAAElFTkSuQmCC" />
                    </defs>
                  </svg>

                </div>
              </div>
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}
